import { QueryClient, type QueryClientConfig } from '@tanstack/query-core';

export const initDashboardQueryClient = (
  queryClientOptions?: QueryClientConfig,
) => new QueryClient(queryClientOptions);
